import React from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
// utils
import filter from 'lodash.filter';
// styles
import styles from '../Help.mod.css';

const HelpsList = ({ resources }) => (
  <div className={styles.container}>
    <h2 className="text-center">General information</h2>
    {!!resources.length &&
      resources.map(({ id, title, text }) => (
        <div key={id}>
          <h3>{title}</h3>
          <p>{text}</p>
        </div>
      ))}
  </div>
);

HelpsList.propTypes = {
  resources: T.arrayOf(
    T.shape({
      id: T.number.isRequired,
      title: T.string.isRequired,
      text: T.string.isRequired
    }).isRequired
  ),
  type: T.string.isRequired
};

export default connect((state, props) => ({
  resources: filter(state.helps.resources, {
    help_type: props.type
  })
}))(HelpsList);



// WEBPACK FOOTER //
// ./src/containers/Help/components/HelpsList.jsx